var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMdIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,13.7c-2.6,1-4.6,3.1-5.5,5.7c-1.4,3.7-1.4,7.7-0.1,11.4c0.6,1.8,1.7,3.3,3.1,4.5 c1.8,1.4,4.1,2.1,6.4,1.8c3.7-0.1,6.9-2.5,8.1-6c0.7-1.9,1.1-4,1-6.1c0.1-2.5-0.5-5-1.6-7.2C26.5,13.7,21.6,11.9,17.3,13.7z  M25.7,25.1c0,1.8-0.3,3.5-1,5.2c-0.4,1.2-1.3,2.3-2.5,2.8c-1.9,0.8-4.1,0.1-5.1-1.7c-0.8-1.2-1.3-2.6-1.4-4.1 c-0.4-2.4-0.1-4.9,0.7-7.2c0.4-1.3,1.3-2.3,2.6-3c1.9-0.9,4.2-0.1,5.2,1.7c0.7,1.2,1.2,2.6,1.3,4C25.6,23.6,25.6,24.4,25.7,25.1 L25.7,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.8,28.8c-0.3-1.8-1.5-3.4-3.1-4.3c-1.2-0.7-2.5-1.3-3.7-2c-0.5-0.3-1-0.6-1.5-0.9c-0.4-0.3-0.7-0.7-0.9-1.2 c-0.5-1.3,0.2-2.7,1.5-3.1c1-0.4,2.1-0.5,3.2-0.2c0.9,0.2,1.9,0.5,2.8,0.8l0.9-3.7c-1-0.3-1.9-0.6-2.8-0.7 c-2.1-0.5-4.2-0.3-6.2,0.5c-2.2,0.8-3.8,2.9-4,5.2c-0.3,2.2,0.7,4.5,2.6,5.7c1.1,0.8,2.4,1.5,3.7,2.1c0.7,0.4,1.4,0.8,2.1,1.3 c0.4,0.3,0.7,0.7,0.8,1.2c0.5,1.4-0.2,3-1.7,3.6c-1.3,0.4-2.6,0.5-3.9,0.1c-1-0.2-2.1-0.6-3.1-1c-0.2,1-0.5,2-0.7,3 c-0.2,0.7-0.2,0.7,0.5,0.9c2.7,1.1,5.7,1.3,8.6,0.5C45.4,35.7,47.6,32.3,46.8,28.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 19.9,
    className: "st0",
    width: 4.4,
    height: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,12.9C4.1,12.9,3,14,3,15.3c0,1.3,1.1,2.4,2.5,2.3c0,0,0.1,0,0.1,0c1.3-0.1,2.3-1.2,2.2-2.4 c0,0,0-0.1,0-0.1C7.7,13.8,6.7,12.8,5.4,12.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMdIos);
export default __webpack_public_path__ + "static/media/Icon-MD-IOS.f08bf3f7a39399e404f840267ccb4c6f.svg";
export { ForwardRef as ReactComponent };